import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { buildVersion } from "util/version";

interface ServerVersionPayload {
    serverVersion: string;
    deployTimestamp: number;
}

interface ServerBuildState {
    serverVersion: string;
    deployTimestamp: number;
}

const initialState: ServerBuildState = {
    serverVersion: buildVersion,
    deployTimestamp: -1,
};

export const serverBuildSlice = createSlice({
    name: "serverBuild",
    initialState,
    reducers: {
        serverVersionReceived: (state, action: PayloadAction<ServerVersionPayload>) => {
            if (
                action.payload.deployTimestamp &&
                action.payload.deployTimestamp > state.deployTimestamp
            ) {
                state.serverVersion = action.payload.serverVersion;
                state.deployTimestamp = action.payload.deployTimestamp;
            }
        },
    },
});
